import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { KVPosition, KVPositionJSON, KVRotation, KVRotationJSON } from 'types'

import { KVMessageDef } from './index'

export function getSliceOnOrbitMessage() {
  return {
    type: 'sliceOnOrbitResponse',
    requiredData: ['planeLocation', 'planeRotation'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      const position = KVPosition.fromJSON(json.planeLocation as KVPositionJSON)
      const rotation = KVRotation.fromJSON(json.planeRotation as KVRotationJSON)

      if (kv.setPlanePosition) {
        kv.setPlanePosition(position)
      }

      if (kv.setPlaneRotation) {
        kv.setPlaneRotation(rotation)
      }
    },
  } as KVMessageDef
}
